import { Component, Input, OnInit } from '@angular/core';
import { IcecontrolSettings } from '../models/icesettings';

@Component({
  selector: 'icepaypalsimplesubscribe',
  templateUrl: './icepaypalsimplesubscribe.component.html',
  styleUrls: ['./icepaypalsimplesubscribe.component.scss']
})
export class IcepaypalsimplesubscribeComponent implements OnInit {
  @Input() id: string = "";
  @Input() properties: any = {};
  @Input() ctrl: IcecontrolSettings = null;

  constructor() { }

  ngOnInit() {
  }

}
